
export class ResourceCategory {
    public ResourceCategoryId:string;

    public Name:string;

    public Description:string;

    public SortOrder:number;

    public IsDeleted:boolean;

    constructor(ResourceCategoryId:string = "", Name:string = ""){
        this.ResourceCategoryId = ResourceCategoryId;
        this.Name = Name;
    }
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/resource-category.ts